import type {IntlShape} from 'react-intl';
import {createToast} from '../toasts/another-toast/toaster';
import {type EditorSurface, trackEditorSaveFailed} from '../../../../tracking/amplitude/editorEvents';
import {convertFromHtmlToDraftJs} from './HtmlToDraftJsConverter';

/**
 * Converts edited html for storage, or tells the user it could not be and returns null.
 *
 * For the surfaces that convert on submit rather than on blur — the comment editors —
 * which call the converter directly and use its result as the mutation payload. A
 * throw there escapes into a click handler and takes out the surrounding tree, and
 * the comment is gone either way.
 *
 * Returning null rather than throwing is what lets the caller do the one thing that
 * actually helps: leave the user in edit mode with their text still on screen, so it
 * can be copied somewhere safe. A caller that submits a null payload would overwrite
 * a comment with nothing.
 */
export const convertEditedHtmlOrNotify = (html: string | undefined, intl: IntlShape, surface: EditorSurface): string | null => {
	try {
		return convertFromHtmlToDraftJs(html);
	} catch {
		// The converter has already reported the throw with the shape of the content.
		// What is left is to say so where the user can see it.
		createToast({
			duration: 8000,
			message: intl.formatMessage({id: 'rich_text_editor.changes_could_not_be_saved'}),
		});
		trackEditorSaveFailed(surface, 'conversion');
		return null;
	}
};
